<ng-container *ngIf="viewModel$ | async as viewModel">

    <div
        class="create-discount-input"
    >
        <ng-template #name>
            <div>
                <label>Name</label>
                <br />
                <input
                    type="text"
                    pInputText
                    [ngModel]="viewModel.discountName"
                    (ngModelChange)="store.dispatch(actions.discountNameInputChanged({ discountName: $event }))"
                    #nameModel="ngModel"
                    placeholder="Name"
                    data-cy="name-text-field"
                    required
                >
                <app-validation-messages
                    [control]="nameModel.control"
                    [requireTouched]="true"
                >
                </app-validation-messages>
                <br>
                <small>Names for single use discounts cannot be reused within the same zone.</small>
            </div>
        </ng-template>
        <ng-template #amount>
            <div class="p-grid">
                <div class="p-col-12">
                    <div class="p-d-flex">
                        <div
                            [style]="{ width: '12rem' }"
                            class="p-fluid p-pr-3"
                        >
                            <label>Discount Type</label>
                            <br />
                            <p-dropdown
                                class="full-width"
                                [options]="discountTypes"
                                [ngModel]="viewModel.discountType"
                                (onChange)="store.dispatch(actions.discountTypeSelected({ discountType: $event.value }))"
                                appendTo="body"
                                data-cy="type-drop-down-field"
                            >
                            </p-dropdown>
                        </div>
                        <div
                            style="flex: 1"
                            [class.p-fluid]="responsiveHelper.isSmallScreen"
                        >
                            <label>Amount</label>
                            <br />
                            <p-inputNumber
                                [ngModel]="viewModel.amount"
                                #amountModel="ngModel"
                                (ngModelChange)="store.dispatch(actions.amountInputChanged({ amount: $event }))"
                                [showButtons]="true"
                                [step]="viewModel.isPercentage ? 1 : 0.25"
                                [mode]="viewModel.isPercentage ? 'decimal' : 'currency'"
                                [suffix]="viewModel.isPercentage ? '%' : undefined"
                                [currency]="viewModel.currency"
                                [minFractionDigits]="viewModel.isPercentage ? 0 : 2"
                                [maxFractionDigits]="viewModel.isPercentage ? 0 : 2"
                                placeholder="Amount"
                                [min]="0"
                                [max]="viewModel.isPercentage ? 100 : undefined"
                                data-cy="amount-number-field"
                            ></p-inputNumber>
                            <br>
                            <app-validation-messages
                                [control]="amountModel.control"
                                [requireTouched]="true"
                            ></app-validation-messages>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #events>
            <div>
                <app-job-event-select
                    [ngModel]="viewModel.eventIds"
                    #eventsModel="ngModel"
                    (ngModelChange)="store.dispatch(actions.eventSelectionChanged({ eventIds: $event }))"
                    [appArrayMinLength]="1"
                >
                </app-job-event-select>
                <app-validation-messages
                    [control]="eventsModel.control"
                    [requireTouched]="true"
                ></app-validation-messages>
            </div>
        </ng-template>
    </div>

    <app-job-mutate-object
        mutateObjectType="discount"
        [steps]="viewModel.steps"
        [templates]="templates"
    ></app-job-mutate-object>
</ng-container>
